import { createFileRoute } from "@tanstack/react-router";
import { useState } from "react";
import { CmmsDashboardPage } from "../components/CmmsDashboard/CmmsDashboardPage";
import { CmmsSampleBanner } from "../components/CmmsDashboard/CmmsSampleData";
import { useRegisterEnterprisePageBanner } from "../components/EnterprisePageChrome";

function CmmsRouteComponent() {
  const [isBannerVisible, setIsBannerVisible] = useState(true);

  useRegisterEnterprisePageBanner(
    isBannerVisible ? (
      <CmmsSampleBanner onDismiss={() => setIsBannerVisible(false)} />
    ) : null,
    [isBannerVisible],
  );

  return <CmmsDashboardPage />;
}

export const Route = createFileRoute("/_app/cmms")({
  component: CmmsRouteComponent,
});
